import React from "react";
import "./why-toffee-card.scss";
import { Col } from "reactstrap";

class WhyToffeeCard extends React.Component {
  state = {
    device: "mobile"
  };
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web"
    });
  }
  render() {
    return (
      <Col lg="4" className="m-0 p-0">
        <div className="card-item">
          <img className="card-icon" src={this.props.data.icon} alt="" />
          <h2 className="card-title  opacity-80">{this.props.data.title}</h2>
          <h3 className="card-sub-title">{this.props.data.subTitle}</h3>
        </div>
      </Col>
    );
  }
}

export default WhyToffeeCard;
